import React, { useEffect, useState } from 'react';
import { Insta_URL, SignUp_URL, Twitter_URL, YouTube_URL } from '../../constants/Constants';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
//import Swal from 'sweetalert2';
import Banner1 from '../../assets/img/banner1.jpg';
import GetAccess1 from '../../assets/img/get3.png';
import GetAccess2 from '../../assets/img/ipad.png';
//import Showcaseimg1 from '../../assets/img/NewWeddingImage.png';
//import TVimg1 from '../../assets/img/tv-img.png';
import Icon from '../../assets/img/d-icon.png';
import Icon2 from '../../assets/img/d-icon2.png';
import ptvBanner from '../../assets/img/ptv-banner.png';
import you3 from '../../assets/img/desktop.png';
import you4 from '../../assets/img/mobile.png';
import you5 from '../../assets/img/laptop.png';
import you6 from '../../assets/img/you6.png';
import banner6 from '../../assets/img/banner6.jpg';
import banner7 from '../../assets/img/banner3.png';
// import smart_tv from '../../assets/img/smart-tv.jpg';
import smart_tv from '../../assets/img/TVf.png';

import s1 from '../../assets/img/s1.png';
import s2 from '../../assets/img/s2.png';
import s3 from '../../assets/img/s3.png';
import s4 from '../../assets/img/s4.png';

import Pricing from '../../components/pricing';
import android_tv from '../../assets/img/android_tv.png';
import lg_webos from '../../assets/img/lg-webos.png';
import samsung_tv from '../../assets/img/samsung-logo-new.png';

import { Link, useNavigate } from 'react-router-dom';
import { Link as ReactScrollLink } from 'react-scroll';
import * as Handler from '../../helpers/api/Handler';
import key1 from '../../assets/img/key1.png';
import key2 from '../../assets/img/key2.png';
import key3 from '../../assets/img/key3.png';
import key4 from '../../assets/img/key4.png';
import key5 from '../../assets/img/key5.png';
import ContactUsPage from '../ContactUs/contactUs';
//import FooterPage from '../../components/Footer/footer';

export default function LandingPage() {
	const videoSrc = require('../../assets/videos/CORPORATE_WEBSITE_TV_Video-1.mp4') as string;
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		name: '',
		phoneNumber: '',
		email: '',
		message: '',
	});

	const [overviewData, setOverviewData] = useState<{
		projectShared: 0;
		clientServed: 0;
		dataUploaded: '0 GB';
		filmMakers: 0;
	}>();

	const fetchOverviewData = async () => {
		try {
			const response = await Handler.get('/api/Stats/Overview');
			if (response) {
				setOverviewData(response);
			}
		} catch (ex) {
			console.log('network error');
		}
	};
	const handleRedirect = (url: string) => {
		window.location.href = url;
	};
	const settingsSliderMain = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
	};
	const settingsYouGetAccess = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 2,
		slidesToScroll: 2,
		autoplay: true,
		autoplaySpeed: 5500,
		responsive: [
			{
				breakpoint: 1199, // At or below 1024px
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};
	const settingsShowYourWork = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 4,
		autoplay: true,
		autoplaySpeed: 6000,
		responsive: [
			{
				breakpoint: 1599, // At or below 1024px
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 991, // At or below 1024px
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 767, // At or below 1024px
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};
	const settingsKeyFeatures = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 4,
		autoplay: true,
		autoplaySpeed: 6500,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
		],
	};
	const settingsTestimonial = {
		dots: true,
		infinite: true,
		speed: 500,
		autoplay: true,
		autoplaySpeed: 6000,
		slidesToShow: 2,
		slidesToScroll: 2,
		arrows: false,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false,
					variableWidth: false,
				},
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false,
					variableWidth: false,
				},
			},
		],
	};

	useEffect(() => {
		fetchOverviewData();
		// Set interval to fetch data every 10 seconds
		const interval = setInterval(() => {
			fetchOverviewData();
		}, 300000); // 5 min

		// Cleanup interval on component unmount
		return () => clearInterval(interval);
	}, []);
	return (
		<>
			<section className="main-hero-banner blockElement">
				<div className="slider-main">
					<Slider {...settingsSliderMain}>
						<div className="slide">
							<div className="slider-inner blockElement">
								<img src={Banner1} alt="" />
								<div className="content-over-slide">
									<h6>streamefy Your Masterpiece: </h6>
									<h1>Filmmaker's Ultimate ecosystem</h1>
									<Link
										to=""
										onClick={(e) => {
											e.preventDefault();
											handleRedirect(SignUp_URL);
										}}
										className="cmn-btn"
									>
										<span>
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path
													d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
													fill="white"
												/>
											</svg>
											start free trial
										</span>
									</Link>
								</div>
							</div>
						</div>
						<div className="slide">
							<div className="slider-inner blockElement">
								<img src={banner6} alt="" />
								<div className="content-over-slide">
									<h6>streamefy Your Masterpiece: </h6>
									<h1>download 4K quality videos</h1>
									<Link
										to=""
										onClick={(e) => {
											e.preventDefault();
											handleRedirect(SignUp_URL);
										}}
										className="cmn-btn"
									>
										<span>
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path
													d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
													fill="white"
												/>
											</svg>
											start free trial
										</span>
									</Link>
								</div>
							</div>
						</div>
						<div className="slide">
							<div className="slider-inner blockElement">
								<img src={banner7} alt="" />
								<div className="content-over-slide">
									<h6>streamefy Your Masterpiece: </h6>
									<h1>secure content delivery</h1>
									<Link
										to=""
										onClick={(e) => {
											e.preventDefault();
											handleRedirect(SignUp_URL);
										}}
										className="cmn-btn"
									>
										<span>
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path
													d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
													fill="white"
												/>
											</svg>
											start free trial
										</span>
									</Link>
								</div>
							</div>
						</div>
					</Slider>
					{/* <div className="slide">
						<div className="slider-inner blockElement">
							<img src="assets/images/banner1.jpg" alt="" />
							<div className="content-over-slide">
								<h6>streamefy Your Masterpiece: </h6>
								<h1>Filmmaker's Ultimate ecosystem</h1>
							</div>
						</div>
					</div> */}
					{/* <div className="slide">
						<div className="slider-inner blockElement">
							<img src="assets/images/banner1.jpg" alt="" />
							<div className="content-over-slide">
								<h6>streamefy Your Masterpiece: </h6>
								<h1>Filmmaker's Ultimate ecosystem</h1>
							</div>
						</div>
					</div> */}
					{/* <div className="slide">
						<div className="slider-inner blockElement">
							<img src="assets/images/banner1.jpg" alt="" />
							<div className="content-over-slide">
								<h6>streamefy Your Masterpiece: </h6>
								<h1>Filmmaker's Ultimate ecosystem</h1>
							</div>
						</div>
					</div> */}
				</div>
				<ul className="social-media-icons">
					<li>
						<Link
							to=""
							onClick={(e) => {
								e.preventDefault();
								handleRedirect(Insta_URL);
							}}
						>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M7.8 2H16.2C19.4032 2 22 4.59675 22 7.8V16.2C22 19.4033 19.4032 22 16.2 22H7.8C4.59675 22 2 19.4033 2 16.2V7.8C2 4.59675 4.59675 2 7.8 2ZM7.6 3.99998C5.61177 3.99998 4 5.61176 4 7.59998V16.4C4 18.3882 5.61177 20 7.6 20H16.4C18.3882 20 20 18.3882 20 16.4V7.59998C20 5.61176 18.3882 3.99998 16.4 3.99998H7.6ZM17.25 5.49998C17.9404 5.49998 18.5 6.05963 18.5 6.74998C18.5 7.44034 17.9404 7.99998 17.25 7.99998C16.5596 7.99998 16 7.44034 16 6.74998C16 6.05963 16.5596 5.49998 17.25 5.49998ZM12 6.99998C14.7614 6.99998 17 9.23856 17 12C17 14.7614 14.7614 17 12 17C9.23857 17 7 14.7614 7 12C7 9.23856 9.23857 6.99998 12 6.99998ZM12 8.99998C10.3431 8.99998 9 10.3432 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 8.99998 12 8.99998Z"
									fill="white"
								/>
							</svg>
						</Link>
					</li>
					<li>
						<Link
							to=""
							onClick={(e) => {
								e.preventDefault();
								handleRedirect(Twitter_URL);
							}}
						>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M8.82356 0.693115H0L10.4616 13.7446L0.669248 24.6931H5.19359L12.5999 16.4124L19.1764 24.6169H28L17.2344 11.1862L17.2535 11.2093L26.5228 0.845523H21.9985L15.1148 8.54188L8.82356 0.693115ZM4.87046 2.97885H7.61738L23.1295 22.3312H20.3826L4.87046 2.97885Z"
									fill="white"
								/>
							</svg>
						</Link>
					</li>
					<li>
						<Link to="">
							<svg width="13" height="25" viewBox="0 0 13 25" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M8.66667 14.375H11.7619L13 9.375H8.66667V6.875C8.66667 5.5875 8.66667 4.375 11.1429 4.375H13V0.175C12.5964 0.12125 11.0723 0 9.46276 0C6.10133 0 3.71429 2.07125 3.71429 5.875V9.375H0V14.375H3.71429V25H8.66667V14.375Z"
									fill="white"
								/>
							</svg>
						</Link>
					</li>
					{/* <li>
						<Link
							to=""
							onClick={(e) => {
								e.preventDefault();
								handleRedirect(YouTube_URL);
							}}
						>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none">
								<path
									d="M1.60986 0.716553H3.76419L5.15188 4.98668H5.28608L6.6095 0.716553H8.7823L6.29291 6.96677V11.4006H4.15457V7.16562L1.60986 0.716553ZM9.00857 5.31766C9.00857 4.69076 9.26614 4.19252 9.78168 3.82057C10.2966 3.44866 10.9887 3.26271 11.8582 3.26271C12.6501 3.26271 13.2986 3.45921 13.8038 3.85099C14.3103 4.24277 14.5629 4.74687 14.5629 5.36444V9.54569C14.5629 10.2381 14.3144 10.7819 13.8191 11.1761C13.3232 11.5702 12.6401 11.7679 11.7714 11.7679C10.9342 11.7679 10.2647 11.5644 9.76203 11.1574C9.26005 10.7504 9.00857 10.203 9.00857 9.5141V5.31766ZM10.9779 9.66612C10.9779 9.88952 11.0454 10.0603 11.182 10.1831C11.3182 10.3047 11.5127 10.3644 11.7656 10.3644C12.0249 10.3644 12.2311 10.3036 12.3834 10.1796C12.5361 10.0545 12.6127 9.88366 12.6127 9.66612V5.25682C12.6127 5.08019 12.5343 4.93751 12.3788 4.82876C12.2233 4.71996 12.0188 4.66498 11.7656 4.66498C11.5325 4.66498 11.3425 4.71996 11.1969 4.82876C11.0507 4.93751 10.9779 5.08019 10.9779 5.25682V9.66612ZM21.5616 3.39255V11.4884H19.6453V10.5948C19.2915 10.9247 18.9243 11.1749 18.5418 11.348C18.1599 11.5188 17.7886 11.6053 17.4295 11.6053C16.9863 11.6053 16.6517 11.4849 16.4271 11.2439C16.2026 11.0029 16.0903 10.6416 16.0903 10.1597V3.39255H18.0073V9.59833C18.0073 9.79132 18.0476 9.92932 18.1277 10.0159C18.2085 10.1013 18.3383 10.1445 18.5178 10.1445C18.6593 10.1445 18.8377 10.0872 19.0522 9.97376C19.268 9.86032 19.4656 9.71529 19.6452 9.53866V3.39255H21.5616ZM19.7658 17.721C19.6716 17.6169 19.5219 17.5631 19.3161 17.5631C19.1009 17.5631 18.9465 17.6169 18.853 17.721C18.7594 17.8263 18.7126 18.0005 18.7126 18.2438V18.7479H19.9067V18.2438C19.9067 18.0005 19.8599 17.8263 19.7658 17.721ZM14.1021 21.5163C14.205 21.5584 14.3138 21.5783 14.4284 21.5783C14.5945 21.5783 14.7149 21.5385 14.7933 21.4566C14.8716 21.3759 14.9102 21.2414 14.9102 21.0566V18.1421C14.9102 17.9456 14.8623 17.7971 14.7664 17.6953C14.6699 17.5935 14.529 17.5432 14.3466 17.5432C14.25 17.5432 14.1547 17.5619 14.0605 17.5994C13.9664 17.638 13.8734 17.6976 13.7816 17.7771V21.3116C13.8916 21.4075 13.9986 21.4753 14.1021 21.5163ZM22.9915 15.3456C22.9915 13.9421 21.5499 12.8041 19.7734 12.8041C17.2389 12.7187 14.6454 12.6813 11.9995 12.6859C9.3545 12.6813 6.76096 12.7187 4.22563 12.8041C2.44996 12.8041 1.00846 13.9421 1.00846 15.3456C0.901722 16.4555 0.855503 17.5666 0.859628 18.6777C0.85555 19.7888 0.901722 20.8999 1.00846 22.011C1.00846 23.4133 2.44996 24.5513 4.22563 24.5513C6.76096 24.6355 9.3545 24.673 11.9995 24.6694C14.6454 24.673 17.2389 24.6355 19.7734 24.5513C21.5499 24.5513 22.9915 23.4133 22.9915 22.011C23.0979 20.8999 23.1441 19.7888 23.1394 18.6777C23.1441 17.5666 23.0979 16.4555 22.9915 15.3456ZM5.68316 22.418V22.5023H4.16099V22.418V15.7702H2.58617V15.6872V14.6276V14.5445H7.2583V14.6276V15.6872V15.7702H5.68316V22.418ZM11.098 16.693V22.418V22.5023H9.74657V22.418V21.8602C9.49686 22.0976 9.23807 22.2765 8.96882 22.4005C8.69896 22.5233 8.43753 22.5853 8.18375 22.5853C7.87147 22.5853 7.63607 22.4987 7.47758 22.3268C7.31882 22.1537 7.23955 21.8941 7.23955 21.5479V21.4636V16.693V16.6099H8.59161V16.693V21.0625C8.59161 21.1993 8.61969 21.2999 8.67608 21.3607C8.73313 21.4227 8.82491 21.4531 8.95152 21.4531C9.05122 21.4531 9.17666 21.4122 9.32872 21.3315C9.48017 21.2496 9.61935 21.1455 9.74657 21.0192V16.693V16.6099H11.098V16.693ZM16.3015 18.0766V21.2145V21.2988C16.3015 21.7116 16.1956 22.0274 15.984 22.2473C15.7722 22.4648 15.4658 22.5747 15.0658 22.5747C14.8015 22.5747 14.5665 22.5326 14.3594 22.4484C14.1518 22.3631 13.9595 22.232 13.7817 22.0554V22.418V22.5022H12.4174V22.418V14.6275V14.5445H13.7817V14.6275V17.0789C13.9641 16.9011 14.1571 16.7666 14.3618 16.6754C14.5671 16.583 14.7747 16.5363 14.984 16.5363C15.4108 16.5363 15.7384 16.6602 15.9635 16.9082C16.1886 17.1561 16.3015 17.5175 16.3015 17.9924V18.0766ZM21.2979 18.2544V19.6497V19.7339H18.7126V20.7455C18.7126 21.0508 18.757 21.2625 18.8459 21.3806C18.9354 21.4988 19.0874 21.5584 19.3026 21.5584C19.5266 21.5584 19.6839 21.5081 19.7734 21.4076C19.8622 21.3081 19.9067 21.0871 19.9067 20.7455V20.4263V20.3421H21.2979V20.4263V20.7783V20.8625C21.2979 21.4578 21.1289 21.9058 20.7898 22.2075C20.4511 22.5093 19.9453 22.659 19.2722 22.659C18.667 22.659 18.191 22.4988 17.843 22.1795C17.4957 21.8602 17.3214 21.4204 17.3214 20.8625V20.7783V18.2544V18.1714C17.3214 17.6673 17.5126 17.2567 17.8939 16.9386C18.2758 16.6216 18.77 16.4626 19.3746 16.4626C19.9933 16.4626 20.4681 16.6099 20.8003 16.9035C21.1313 17.1971 21.2979 17.6205 21.2979 18.1714V18.2544H21.2979Z"
									fill="white"
								/>
							</svg>
						</Link>
					</li> */}
				</ul>
			</section>

			<section className="page-main-outer blockElement">
				<div className="you-get-access blockElement" id="you-get-access">
					<div className="container">
						<div className="inner-you-get blockElement">
							<h2>You Get access to</h2>
							<Slider {...settingsYouGetAccess}>
								<div className="slide-item">
									<div className="single-you-get blockElement">
										<div className="inner-single-slider-get blockElement">
											<div className="inner-inner-single-slide-get blockElement">
												<img src={GetAccess1} alt="" />
												<div className="content-get">
													<h5>World's First Elite OTT Streaming Platform</h5>
													<p>Enhance customer experience with our special feature of publishing your app as an OTT application</p>
													<Link
														to=""
														onClick={(e) => {
															e.preventDefault();
															handleRedirect(SignUp_URL);
														}}
														className="cmn-btn"
													>
														<span>
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
																	fill="white"
																/>
															</svg>
															try for free
														</span>
													</Link>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="slide-item">
									<div className="single-you-get blockElement">
										<div className="inner-single-slider-get blockElement">
											<div className="inner-inner-single-slide-get blockElement">
												<img src={GetAccess2} alt="" />
												<div className="content-get">
													<h5>Custom Branding</h5>
													<p>Provide your brand details to showcase your work through our platform.</p>
													<Link
														to=""
														onClick={(e) => {
															e.preventDefault();
															handleRedirect(SignUp_URL);
														}}
														className="cmn-btn"
													>
														<span>
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
																	fill="white"
																/>
															</svg>
															try for free
														</span>
													</Link>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="slide-item">
									<div className="single-you-get blockElement">
										<div className="inner-single-slider-get blockElement">
											<div className="inner-inner-single-slide-get blockElement">
												<img src={you3} alt="" />
												<div className="content-get">
													<h5>Get detailed analytics of your business</h5>
													<p>
														Gain valuable insights through detailed analytics reports, providing in-depth visibility into key business metrics and
														performance indicators.
													</p>
													<Link
														to=""
														onClick={(e) => {
															e.preventDefault();
															handleRedirect(SignUp_URL);
														}}
														className="cmn-btn"
													>
														<span>
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
																	fill="white"
																/>
															</svg>
															try for free
														</span>
													</Link>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="slide-item">
									<div className="single-you-get blockElement">
										<div className="inner-single-slider-get blockElement">
											<div className="inner-inner-single-slide-get blockElement">
												<img src={you4} alt="" />
												<div className="content-get">
													<h5>Enhance privacy with secure, password- protected link sharing</h5>
													<p>Share your project links with your clients by setting the password to ensure the security of client’s videos</p>
													<Link
														to=""
														onClick={(e) => {
															e.preventDefault();
															handleRedirect(SignUp_URL);
														}}
														className="cmn-btn"
													>
														<span>
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
																	fill="white"
																/>
															</svg>
															try for free
														</span>
													</Link>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="slide-item">
									<div className="single-you-get blockElement">
										<div className="inner-single-slider-get blockElement">
											<div className="inner-inner-single-slide-get blockElement">
												<img src={you5} alt="" />
												<div className="content-get">
													<h5>Premium viewing experience</h5>
													<p>Deliver an exceptional viewing experience that your viewers will adore.</p>
													<Link
														to=""
														onClick={(e) => {
															e.preventDefault();
															handleRedirect(SignUp_URL);
														}}
														className="cmn-btn"
													>
														<span>
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
																	fill="white"
																/>
															</svg>
															try for free
														</span>
													</Link>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="slide-item">
									<div className="single-you-get blockElement">
										<div className="inner-single-slider-get blockElement">
											<div className="inner-inner-single-slide-get blockElement">
												<img src={you6} alt="" />
												<div className="content-get">
													<h5>Craft Projects with step-by-step guided tour</h5>
													<p>
														Effortlessly create and share project events with your clients. Our platform streamlines the process, allowing filmmakers
													</p>
													<Link
														to=""
														onClick={(e) => {
															e.preventDefault();
															handleRedirect(SignUp_URL);
														}}
														className="cmn-btn"
													>
														<span>
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
																	fill="white"
																/>
															</svg>
															try for free
														</span>
													</Link>
												</div>
											</div>
										</div>
									</div>
								</div>
							</Slider>
						</div>
					</div>
				</div>

				<div className="counting-section blockElement">
					<div className="container">
						<div className="inner-counting-section">
							<div className="row">
								<div className="col-md-3">
									<div className="single-counter">
										<h2>{overviewData?.projectShared}</h2>
										<p>projects shared</p>
									</div>
								</div>
								<div className="col-md-3">
									<div className="single-counter">
										<h2>{overviewData?.filmMakers}</h2>
										<p>Filmmakers</p>
									</div>
								</div>
								<div className="col-md-3">
									<div className="single-counter">
										<h2>{overviewData?.dataUploaded}</h2>
										<p>DATA UPLOADED</p>
									</div>
								</div>
								<div className="col-md-3">
									<div className="single-counter">
										<h2>{overviewData?.clientServed}</h2>
										<p>CLIENTS SERVED</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<Pricing />

				<div className="plans">
					<div className="container">
						<div className="inner-plans">
							<div className="plans-text">
								{/* <div className="discount-text">Save 10% discount annually</div> */}
								<h2>
									Grow Your Brand with a <span>Personalized</span> OTT Experience
								</h2>
								<p>Enhance your brand’s presence and reach with a tailored OTT platform, reflecting your unique identity.</p>
							</div>
							<div className="plans-info">
								<div className="inner-plan-info">
									<div className="plans-heading">
										<div className="pre-quality">
											<svg
												fill="#941af2"
												version="1.1"
												id="Capa_1"
												xmlns="http://www.w3.org/2000/svg"
												width="70px"
												height="70px"
												viewBox="0 0 940.017 940.017"
											>
												<g>
													<g>
														<path
															d="M630.009,667.5c-0.6,0-1.2,0-1.8,0l-39.601-1.5l-29.399,26.6c-9.2,8.301-21.101,12.9-33.5,12.9
			c-6.5,0-12.9-1.199-18.9-3.699l-36.7-15l-36.699,15c-6,2.5-12.4,3.699-18.9,3.699c-12.4,0-24.3-4.6-33.5-12.9l-29.4-26.6
			l-39.6,1.5c-0.6,0-1.2,0-1.8,0c-18.601,0-35.5-10.199-44.2-26.699l-18.5-35.102l-1.5-0.5V914.9c0,18.6,19.601,30.699,36.2,22.299
			l176.8-88.799c7.1-3.5,15.4-3.5,22.5,0l176.5,88.9c16.6,8.398,36.2-3.701,36.2-22.301V605.301l-1.5,0.5l-18.5,35.1
			C665.608,657.301,648.608,667.5,630.009,667.5z"
														/>
														<path
															d="M811.209,353.6c5.1-8.1,5.1-18.4,0-26.6l-21.101-33.6c-3.5-5.5-4.6-12.2-3.3-18.5l8.4-38.8c2-9.4-1.5-19.1-9.101-25
			l-31.3-24.3c-5.1-4-8.5-9.8-9.399-16.3l-5.5-39.3c-1.301-9.5-8-17.4-17.101-20.4l-37.7-12.2c-6.199-2-11.399-6.4-14.399-12.1
			l-18.5-35.1c-4.3-8.2-12.9-13.3-22.101-13.3c-0.3,0-0.6,0-0.899,0l-39.601,1.5c-0.3,0-0.6,0-0.899,0c-6.2,0-12.2-2.3-16.8-6.5
			l-29.4-26.6c-4.7-4.2-10.7-6.5-16.8-6.5c-3.2,0-6.4,0.6-9.4,1.9l-36.7,15c-3,1.2-6.199,1.9-9.399,1.9s-6.4-0.6-9.4-1.9l-36.7-15
			c-3.1-1.2-6.3-1.9-9.399-1.9c-6.101,0-12.101,2.2-16.8,6.5l-29.4,26.6c-4.6,4.2-10.6,6.5-16.8,6.5c-0.3,0-0.601,0-0.9,0l-39.6-1.5
			c-0.3,0-0.601,0-0.9,0c-9.2,0-17.8,5.1-22.1,13.3l-18.5,35.1c-3,5.8-8.2,10.1-14.399,12.1l-37.7,12.2
			c-9.101,2.9-15.8,10.9-17.101,20.4l-5.5,39.3c-0.899,6.5-4.3,12.3-9.399,16.3l-31.7,24.3c-7.601,5.9-11.101,15.6-9.101,25
			l8.4,38.8c1.4,6.4,0.2,13-3.3,18.5L128.809,327c-5.1,8.1-5.1,18.4,0,26.6l21.101,33.6c3.5,5.5,4.6,12.2,3.3,18.5l-8.4,38.801
			c-2,9.399,1.5,19.1,9.101,25l31.3,24.3c5.1,4,8.5,9.799,9.4,16.299l5.5,39.301c1.3,9.5,8,17.4,17.1,20.4l28.6,9.199l9.2,3
			c6.2,2,11.4,6.4,14.4,12.1l18.5,35.1c4.3,8.201,12.899,13.301,22.1,13.301c0.3,0,0.6,0,0.9,0l39.6-1.5c0.3,0,0.6,0,0.9,0
			c6.199,0,12.199,2.301,16.8,6.5l29.399,26.6c4.7,4.201,10.7,6.5,16.801,6.5c3.199,0,6.399-0.6,9.399-1.9l36.7-15
			c3-1.199,6.2-1.898,9.4-1.898c3.199,0,6.399,0.6,9.399,1.898l36.7,15c3.1,1.201,6.3,1.9,9.4,1.9c6.1,0,12.1-2.199,16.8-6.5
			l29.399-26.6c4.601-4.199,10.601-6.5,16.801-6.5c0.3,0,0.6,0,0.899,0l39.601,1.5c0.3,0,0.6,0,0.899,0
			c9.2,0,17.8-5.1,22.101-13.301l18.5-35.1c3-5.799,8.199-10.1,14.399-12.1l9.2-3l28.6-9.199c9.101-2.9,15.801-10.9,17.101-20.4
			l5.5-39.301c0.899-6.5,4.3-12.299,9.399-16.299l31.301-24.3c7.6-5.9,11.1-15.601,9.1-25l-8.4-38.801
			c-1.399-6.399-0.199-13,3.301-18.5L811.209,353.6z M711.909,442.5c-5.101,11.899-10.9,23.399-17.601,34.4
			c-10.8,17.699-23.7,34.199-38.6,49c-24.101,24.1-52.2,43-83.4,56.199c-32.399,13.701-66.8,20.6-102.2,20.6
			c-35.399,0-69.8-6.898-102.199-20.6c-31.301-13.199-59.301-32.1-83.4-56.199c-14.899-14.9-27.8-31.301-38.6-49
			c-6.7-11-12.601-22.4-17.601-34.4c-13.699-32.4-20.6-66.801-20.6-102.2c0-35.4,6.9-69.8,20.6-102.2
			c13.2-31.3,32.101-59.3,56.2-83.4s52.2-43,83.4-56.2c32.399-13.7,66.8-20.6,102.199-20.6c35.4,0,69.801,6.9,102.2,20.6
			c31.3,13.2,59.3,32.1,83.4,56.2c24.1,24.1,43,52.2,56.2,83.4c13.699,32.4,20.6,66.8,20.6,102.2
			C732.509,375.7,725.608,410.1,711.909,442.5z"
														/>
														<path
															d="M470.009,107.8c-128.4,0-232.5,104.1-232.5,232.5c0,21.3,2.9,42,8.3,61.6c27,98.5,117.2,170.901,224.2,170.901
			s197.2-72.4,224.2-170.901c5.399-19.6,8.3-40.3,8.3-61.6C702.509,211.9,598.409,107.8,470.009,107.8z M573.509,448
			c4.5,21.1-18,37.599-36.8,26.9l-66.7-37.8l-66.8,37.8c-18.7,10.6-41.3-5.9-36.8-26.9l16-75.4l-52.2-47.1l-5.8-5.3
			c-15.9-14.4-7.5-40.8,13.699-43.4l76-9.3l33.101-70.9c9-19.2,36.3-19.2,45.3,0l33.1,70.9l76,9.3c21.301,2.6,29.601,29,13.7,43.4
			l-5.8,5.3l-52.2,47.1L573.509,448z"
														/>
													</g>
												</g>
											</svg>
										</div>
										<div className="best-plans-btn">OTT plan</div>
										<p>A best plan for individuals or teams to stream their content</p>
										<div className="price-text">
											$1400<span> /Per year</span>
										</div>
										<span>Make Your Brand Unforgettable with Personalization.</span>
									</div>
									<ul>
										<li>
											<span>
												<svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
													<ellipse cx="13.3447" cy="13.5018" rx="8.73548" ry="8.73543" fill="#E9E9E9" />
													<path
														d="M10.6149 13.5017L12.6927 15.5795C12.7513 15.6381 12.8463 15.6381 12.9048 15.5795L17.1665 11.3179"
														stroke="#222222"
														stroke-width="1.2"
													/>
												</svg>
											</span>
											Your Brand, Your Look
										</li>
										<li>
											<span>
												<svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
													<ellipse cx="13.3447" cy="13.5018" rx="8.73548" ry="8.73543" fill="#E9E9E9" />
													<path
														d="M10.6149 13.5017L12.6927 15.5795C12.7513 15.6381 12.8463 15.6381 12.9048 15.5795L17.1665 11.3179"
														stroke="#222222"
														stroke-width="1.2"
													/>
												</svg>
											</span>
											No Coding Required
										</li>
										<li>
											<span>
												<svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
													<ellipse cx="13.3447" cy="13.5018" rx="8.73548" ry="8.73543" fill="#E9E9E9" />
													<path
														d="M10.6149 13.5017L12.6927 15.5795C12.7513 15.6381 12.8463 15.6381 12.9048 15.5795L17.1665 11.3179"
														stroke="#222222"
														stroke-width="1.2"
													/>
												</svg>
											</span>
											Multi-Platform Ready
										</li>
										<li>
											<span>
												<svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
													<ellipse cx="13.3447" cy="13.5018" rx="8.73548" ry="8.73543" fill="#E9E9E9" />
													<path
														d="M10.6149 13.5017L12.6927 15.5795C12.7513 15.6381 12.8463 15.6381 12.9048 15.5795L17.1665 11.3179"
														stroke="#222222"
														stroke-width="1.2"
													/>
												</svg>
											</span>
											Fully Customize Branding
										</li>
										<li>
											<span>
												<svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
													<ellipse cx="13.3447" cy="13.5018" rx="8.73548" ry="8.73543" fill="#E9E9E9" />
													<path
														d="M10.6149 13.5017L12.6927 15.5795C12.7513 15.6381 12.8463 15.6381 12.9048 15.5795L17.1665 11.3179"
														stroke="#222222"
														stroke-width="1.2"
													/>
												</svg>
											</span>
											Premium content delivery
										</li>
									</ul>
									<div className="buy-now">
										<Link to="/personalized" className="cmn-btn btn-price-area">
											<span>
												<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path
														d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
														fill="white"
													></path>
												</svg>
												Know More
											</span>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="show-your-work blockElement">
					<div className="container">
						<div className="inner-showcase">
							<h2>Showcase your work</h2>
							<div className="work-showcase-slide" id="work-slider">
								<Slider {...settingsShowYourWork}>
									<div className="slide-item">
										<div className="border-gradiant">
											<div className="single-showcase">
												<div className="main-div-showcase">
													<img src={s1} alt="" />
													<h6>Wedding Films</h6>
												</div>
												<div className="overlay-showcase">
													<h6>Wedding Films</h6>
													<p>
														Wedding filmmakers can effortlessly upload and share their shooted wedding videos on Streamefy, offering clients a
														high-quality, cinematic viewing experience. Clients can access their personalized wedding films directly through the
														platform's OTT service, enjoying seamless streaming and the ability to relive their special moments anytime, anywhere,
														with premium video playback.
													</p>
													<Link
														to=""
														onClick={(e) => {
															e.preventDefault();
															handleRedirect(SignUp_URL);
														}}
														className="cmn-btn"
													>
														<span>
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
																	fill="white"
																/>
															</svg>
															try for free
														</span>
													</Link>
												</div>
											</div>
										</div>
									</div>
									<div className="slide-item">
										<div className="border-gradiant">
											<div className="single-showcase">
												<div className="main-div-showcase">
													<img src={s2} alt="" />
													<h6>Enterprise Video</h6>
												</div>
												<div className="overlay-showcase">
													<h6>Enterprise Video</h6>
													<p>
														Elevate your corporate storytelling with Streamefy. Upload and securely share company profiles, product demos, and
														training sessions, ensuring professional and accessible content for your team and clients.
													</p>
													<Link
														to=""
														onClick={(e) => {
															e.preventDefault();
															handleRedirect(SignUp_URL);
														}}
														className="cmn-btn"
													>
														<span>
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
																	fill="white"
																/>
															</svg>
															try for free
														</span>
													</Link>
												</div>
											</div>
										</div>
									</div>
									<div className="slide-item">
										<div className="border-gradiant">
											<div className="single-showcase">
												<div className="main-div-showcase">
													<img src={s3} alt="" />
													<h6>Video Productions</h6>
												</div>
												<div className="overlay-showcase">
													<h6>Video Productions</h6>
													<p>
														Whether you’re creating short films, documentaries, or any other type of video project, Streamefy is the perfect platform
														to showcase your work. Share your creative projects with your audience in high quality, and engage with viewers through
														secure and professional video-sharing.
													</p>
													<a href="https://app.streamefy.com/?tabId=0" className="cmn-btn">
														<span>
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
																	fill="white"
																/>
															</svg>
															try for free
														</span>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="slide-item">
										<div className="border-gradiant">
											<div className="single-showcase">
												<div className="main-div-showcase">
													<img src={s4} alt="" />
													<h6>School Videos</h6>
												</div>
												<div className="overlay-showcase">
													<h6>School Videos</h6>
													<p>
														Streamefy provides students and parents with easy access to educational videos and school events. Schools can upload
														educational series, event coverage, and promotional content to highlight achievements. This feature fosters greater
														engagement by keeping the school community informed about key activities.
													</p>
													<a href="https://app.streamefy.com/?tabId=0" className="cmn-btn">
														<span>
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
																	fill="white"
																/>
															</svg>
															try for free
														</span>
													</a>
												</div>
											</div>
										</div>
									</div>
								</Slider>
							</div>
						</div>
					</div>
				</div>

				<div className="download-section blockElement">
					<div className="container">
						<div className="inner-download-section">
							<div className="row">
								<div className="col-md-6">
									<div className="left-image-download">
										<div className="top-img">
											<video autoPlay muted loop playsInline webkit-playsinline>
												<source src={videoSrc} type="video/mp4" />
												Your browser does not support the video tag.
											</video>
											<img src={smart_tv} alt="" />
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="right-image-download">
										<h2>Download White Label App on:</h2>
										<p>
											Elevate your filmmaking projects with our white-label solution. Design, manage, and deliver your content seamlessly, offering
											your customers an elite viewing experience. With our app, your audience can even enjoy their events on TV.
										</p>
										<div className="buttons-download">
											<Link to={''}>
												<img src={Icon} alt="" />
											</Link>
											<Link to={''}>
												<img src={Icon2} alt="" />
											</Link>
											<Link to={''}>
												<img src={android_tv} alt="" />
											</Link>
											<Link to={''}>
												<img src={lg_webos} alt="" />
											</Link>
											<Link to={''}>
												<img src={samsung_tv} alt="" />
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* <div className="testimonials blockElement">
					<div className="heading-testi">
						<div className="container">
							<div className="inner-heading-testi">
								<h2>Words from the professionals</h2>
								<a
									href=""
									onClick={(e) => {
										e.preventDefault();
										handleRedirect(SignUp_URL);
									}}
									className="cmn-btn"
								>
									<span>
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
												fill="white"
											/>
										</svg>
										start free trial
									</span>
								</a>
							</div>
							<div className="testimonail-slider" id="testimonial-slider">
								<Slider {...settingsTestimonial}>
									<div className="single-slide">
										<div className="inner-single-slide">
											<div className="image-box-testi">
												<img src={box3} alt="" />
												<div className="name-author-testi">
													<h6>Alex Johnson</h6>
													<p>Marketing Manager</p>
												</div>
											</div>
											<div className="content-testi">
												<p>
													"Streamefy has transformed the art of corporate video sharing. The platform beautifully showcases our content, making it
													both captivating and professional. We love the results!”
												</p>
											</div>
										</div>
									</div>
									<div className="single-slide">
										<div className="inner-single-slide">
											<div className="image-box-testi">
												<img src={priyasharma} alt="" />
												<div className="name-author-testi">
													<h6>Emilia</h6>
													<p>Wedding Filmmaker</p>
												</div>
											</div>
											<div className="content-testi">
												<p>
													"Streamefy has changed how I share wedding films with my clients. The secure sharing and high-quality uploads make my work
													look great. It’s been a great tool for my business!”
												</p>
											</div>
										</div>
									</div>
								</Slider>
							</div>
						</div>
					</div>
				</div> */}
				<div className="key-features blockElement">
					<div className="container">
						<div className="inner-key-features">
							<h2>Highlighted key features</h2>
							<div className="key-slider" id="key-slider">
								<Slider {...settingsKeyFeatures}>
									<div className="single-key">
										<div className="icon-single-key">
											<img src={key1} alt="" />
										</div>
										<h6>Download high quality videos</h6>
									</div>
									<div className="single-key">
										<div className="icon-single-key">
											<img src={key2} alt="" />
										</div>
										<h6>Secure sharing & delivery</h6>
									</div>
									<div className="single-key">
										<div className="icon-single-key">
											<img src={key3} alt="" />
										</div>
										<h6>Ad free videos</h6>
									</div>

									<div className="single-key">
										<div className="icon-single-key">
											<img src={key4} alt="" />
										</div>
										<h6>OTT App</h6>
									</div>

									<div className="single-key">
										<div className="icon-single-key">
											<img src={key5} alt="" />
										</div>
										<h6>Make your own cloud library</h6>
									</div>
								</Slider>
							</div>
						</div>
					</div>
				</div>

				<div className="faq-section blockElement">
					<div className="container">
						<div className="inner-faq-section">
							<h2 className="d-none">FAQs</h2>
							<button
								className="accordion-button main-title-area text-center cmn-btn collapsed"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#mainFaq"
								aria-expanded="true"
								aria-controls="collapseOne"
							>
								<h2 className="m-0 text-center">FAQs</h2>
							</button>
							<div className="faqs-main accordion-collapse collapse" id="mainFaq" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
								<div className="single-faq-box">
									<div className="accordion" id="accordionExample">
										<div className="faq-left">
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingOne">
													<button
														className="accordion-button"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseOne"
														aria-expanded="true"
														aria-controls="collapseOne"
													>
														<span>01</span>
														What is Streamefy?
													</button>
												</h2>
												<div
													id="collapseOne"
													className="accordion-collapse collapse show"
													aria-labelledby="headingOne"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														Streamefy is a secure, subscription-based OTT (over-the-top) streaming platform designed primarily for filmmakers and
														content creators. It allows them to upload, store, and stream their videos securely, providing a seamless viewing
														experience similar to popular OTT platforms.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingTwo">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseTwo"
														aria-expanded="false"
														aria-controls="collapseTwo"
													>
														<span>02</span>
														Who can use Streamefy?
													</button>
												</h2>
												<div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
													<div className="accordion-body">
														Streamefy is ideal for professional filmmakers, particularly in the wedding industry, as well as general users who want a
														secure platform to stream personal content. It’s also suited for anyone seeking a private, high-quality OTT streaming
														experience.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingThree">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseThree"
														aria-expanded="false"
														aria-controls="collapseThree"
													>
														<span>03</span>
														Is Streamefy available on mobile and smart TV platforms?
													</button>
												</h2>
												<div
													id="collapseThree"
													className="accordion-collapse collapse"
													aria-labelledby="headingThree"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														Yes, Streamefy is available on mobile devices, Amazon Fire TV, and Android TV, providing users with flexibility in how and
														where they view content.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingFour">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseFour"
														aria-expanded="false"
														aria-controls="collapseFour"
													>
														<span>04</span>
														What are the available subscription plans?
													</button>
												</h2>
												<div
													id="collapseFour"
													className="accordion-collapse collapse"
													aria-labelledby="headingFour"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														Streamefy offers various subscription plans, including the luxury Stream, Prestige Plan and Elite Stream, catering to
														different storage needs and usage levels. Each plan provides access to all features, with the storage capacity varying by
														plan.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingFive">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseFive"
														aria-expanded="false"
														aria-controls="collapseFive"
													>
														<span>05</span>
														Can I change my subscription plan later?
													</button>
												</h2>
												<div
													id="collapseFive"
													className="accordion-collapse collapse"
													aria-labelledby="headingFive"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														Yes, you can upgrade your subscription plan anytime based on your storage needs and usage requirements. As of now we are
														not supporting downgrading the plan.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingSix">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseSix"
														aria-expanded="false"
														aria-controls="collapseSix"
													>
														<span>06</span>
														Can I cancel my subscription at any time?
													</button>
												</h2>
												<div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
													<div className="accordion-body">
														Yes, you can cancel your subscription anytime through the account settings. However, you’ll retain access to your content
														until the end of your billing cycle.
													</div>
												</div>
											</div>
										</div>
										<div className="fqa-right">
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingSeven">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseSeven"
														aria-expanded="false"
														aria-controls="collapseSeven"
													>
														<span>07</span>
														How does Streamefy ensure smooth streaming without buffering?
													</button>
												</h2>
												<div
													id="collapseSeven"
													className="accordion-collapse collapse"
													aria-labelledby="headingSeven"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														Streamefy uses adaptive bitrate streaming to optimize quality based on the viewer’s internet speed, reducing buffering for
														a smoother experience.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingEight">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseEight"
														aria-expanded="false"
														aria-controls="collapseEight"
													>
														<span>08</span>
														Who has access to my videos?
													</button>
												</h2>
												<div
													id="collapseEight"
													className="accordion-collapse collapse"
													aria-labelledby="headingEight"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">Only authorized users, such as those you share links with, can access your videos.</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingNine">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseNine"
														aria-expanded="false"
														aria-controls="collapseNine"
													>
														<span>09</span>
														How is Streamefy different from other OTT platforms?
													</button>
												</h2>
												<div
													id="collapseNine"
													className="accordion-collapse collapse"
													aria-labelledby="headingEight"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														Unlike traditional OTT services, Streamefy is designed specifically for your brand where you get your own OTT application
														for secure and private streaming options.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingTen">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseTen"
														aria-expanded="false"
														aria-controls="collapseTen"
													>
														<span>10</span>
														Can I add extra storage if needed?
													</button>
												</h2>
												<div
													id="collapseTen"
													className="accordion-collapse collapse"
													aria-labelledby="headingNine"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														Yes, you can purchase additional storage if required. The additional storage will extend the capacity of your existing
														plan.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingElven">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseElven"
														aria-expanded="false"
														aria-controls="collapseElven"
													>
														<span>11</span>
														How is my content protected on Streamefy?
													</button>
												</h2>
												<div
													id="collapseElven"
													className="accordion-collapse collapse"
													aria-labelledby="headingElven"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														Streamefy employs encryption for secure data storage and transmission, safeguarding your content against unauthorized
														access.
													</div>
												</div>
											</div>
											<div className="accordion-item">
												<h2 className="accordion-header" id="headingTwelve">
													<button
														className="accordion-button collapsed"
														type="button"
														data-bs-toggle="collapse"
														data-bs-target="#collapseTwelve"
														aria-expanded="false"
														aria-controls="collapseTwelve"
													>
														<span>12</span>
														Can I create different pin for different viewers of the same video or presentation?
													</button>
												</h2>
												<div
													id="collapseTwelve"
													className="accordion-collapse collapse"
													aria-labelledby="headingTwelve"
													data-bs-parent="#accordionExample"
												>
													<div className="accordion-body">
														No, Streamefy generates a single PIN for each client, which is then shared with all viewers of the same project.
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="trial-free">
					<div className="container">
						<div className="trial-free-inner">
							<div className="trial-left">
								<h2>Start your free trial today !</h2>
								<p>Create and deliver projects effortlessly with our all-in-one platform. We make your project easy, from start to finish.</p>
								<Link
									to=""
									onClick={(e) => {
										e.preventDefault();
										handleRedirect(SignUp_URL);
									}}
									className="cmn-btn"
								>
									<span>
										<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
												fill="white"
											></path>
										</svg>
										start free trial
									</span>
								</Link>
							</div>
							<div className="trial-right">
								<img src={ptvBanner} alt="pvt banner" />
							</div>
						</div>
					</div>
				</div>

				<div className="footer-sec" id="Contact-US">
					<div className="container">
						<div className="footer-inner">
							<div className="footer-left">
								<div className="footer-left-inner">
									<div className="footer-nav">
										<h3>Quick Links</h3>
										<ul className="nav-list">
											<li>
												{/* <a href="">Features</a> */}
												<ReactScrollLink className="nav-link" to="you-get-access" smooth={true} duration={200}>
													Features
												</ReactScrollLink>
											</li>
											<li className="nav-item">
												<ReactScrollLink className="nav-link" to="pricing-section" smooth={true} duration={200}>
													Pricing
												</ReactScrollLink>
											</li>
											{/* <li className="nav-item">
												<ReactScrollLink className="nav-link" to="footer-main" smooth={true} duration={200}>
													Contact us
												</ReactScrollLink>
											</li> */}
										</ul>
									</div>
									<div className="footer-nav">
										<h3>Follow Us On</h3>
										<ul className="nav-list social">
											<li>
												<Link
													to=""
													onClick={(e) => {
														e.preventDefault();
														handleRedirect(Insta_URL);
													}}
												>
													<div className="icon-footer">
														<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path
																d="M7.8 2H16.2C19.4032 2 22 4.59675 22 7.8V16.2C22 19.4033 19.4032 22 16.2 22H7.8C4.59675 22 2 19.4033 2 16.2V7.8C2 4.59675 4.59675 2 7.8 2ZM7.6 3.99998C5.61177 3.99998 4 5.61176 4 7.59998V16.4C4 18.3882 5.61177 20 7.6 20H16.4C18.3882 20 20 18.3882 20 16.4V7.59998C20 5.61176 18.3882 3.99998 16.4 3.99998H7.6ZM17.25 5.49998C17.9404 5.49998 18.5 6.05963 18.5 6.74998C18.5 7.44034 17.9404 7.99998 17.25 7.99998C16.5596 7.99998 16 7.44034 16 6.74998C16 6.05963 16.5596 5.49998 17.25 5.49998ZM12 6.99998C14.7614 6.99998 17 9.23856 17 12C17 14.7614 14.7614 17 12 17C9.23857 17 7 14.7614 7 12C7 9.23856 9.23857 6.99998 12 6.99998ZM12 8.99998C10.3431 8.99998 9 10.3432 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3432 13.6569 8.99998 12 8.99998Z"
																fill="white"
															/>
														</svg>
													</div>
													instagram
												</Link>
											</li>
											<li>
												<Link
													to=""
													onClick={(e) => {
														e.preventDefault();
														handleRedirect(Twitter_URL);
													}}
												>
													<div className="icon-footer">
														<svg width="28" height="25" viewBox="0 0 29 35" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path
																fillRule="evenodd"
																clipRule="evenodd"
																d="M8.82356 0.693115H0L10.4616 13.7446L0.669248 24.6931H5.19359L12.5999 16.4124L19.1764 24.6169H28L17.2344 11.1862L17.2535 11.2093L26.5228 0.845523H21.9985L15.1148 8.54188L8.82356 0.693115ZM4.87046 2.97885H7.61738L23.1295 22.3312H20.3826L4.87046 2.97885Z"
																fill="white"
															/>
														</svg>
													</div>
													Twitter
												</Link>
											</li>
											<li>
												<Link to="">
													<div className="icon-footer">
														<svg width="13" height="25" viewBox="0 0 13 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path
																d="M8.66667 14.375H11.7619L13 9.375H8.66667V6.875C8.66667 5.5875 8.66667 4.375 11.1429 4.375H13V0.175C12.5964 0.12125 11.0723 0 9.46276 0C6.10133 0 3.71429 2.07125 3.71429 5.875V9.375H0V14.375H3.71429V25H8.66667V14.375Z"
																fill="white"
															/>
														</svg>
													</div>
													Facebook
												</Link>
											</li>
											{/* <li>
												<Link
													to=""
													onClick={(e) => {
														e.preventDefault();
														handleRedirect(YouTube_URL);
													}}
												>
													<div className="icon-footer">
														<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path
																d="M1.60986 0.716553H3.76419L5.15188 4.98668H5.28608L6.6095 0.716553H8.7823L6.29291 6.96677V11.4006H4.15457V7.16562L1.60986 0.716553ZM9.00857 5.31766C9.00857 4.69076 9.26614 4.19252 9.78168 3.82057C10.2966 3.44866 10.9887 3.26271 11.8582 3.26271C12.6501 3.26271 13.2986 3.45921 13.8038 3.85099C14.3103 4.24277 14.5629 4.74687 14.5629 5.36444V9.54569C14.5629 10.2381 14.3144 10.7819 13.8191 11.1761C13.3232 11.5702 12.6401 11.7679 11.7714 11.7679C10.9342 11.7679 10.2647 11.5644 9.76203 11.1574C9.26005 10.7504 9.00857 10.203 9.00857 9.5141V5.31766ZM10.9779 9.66612C10.9779 9.88952 11.0454 10.0603 11.182 10.1831C11.3182 10.3047 11.5127 10.3644 11.7656 10.3644C12.0249 10.3644 12.2311 10.3036 12.3834 10.1796C12.5361 10.0545 12.6127 9.88366 12.6127 9.66612V5.25682C12.6127 5.08019 12.5343 4.93751 12.3788 4.82876C12.2233 4.71996 12.0188 4.66498 11.7656 4.66498C11.5325 4.66498 11.3425 4.71996 11.1969 4.82876C11.0507 4.93751 10.9779 5.08019 10.9779 5.25682V9.66612ZM21.5616 3.39255V11.4884H19.6453V10.5948C19.2915 10.9247 18.9243 11.1749 18.5418 11.348C18.1599 11.5188 17.7886 11.6053 17.4295 11.6053C16.9863 11.6053 16.6517 11.4849 16.4271 11.2439C16.2026 11.0029 16.0903 10.6416 16.0903 10.1597V3.39255H18.0073V9.59833C18.0073 9.79132 18.0476 9.92932 18.1277 10.0159C18.2085 10.1013 18.3383 10.1445 18.5178 10.1445C18.6593 10.1445 18.8377 10.0872 19.0522 9.97376C19.268 9.86032 19.4656 9.71529 19.6452 9.53866V3.39255H21.5616ZM19.7658 17.721C19.6716 17.6169 19.5219 17.5631 19.3161 17.5631C19.1009 17.5631 18.9465 17.6169 18.853 17.721C18.7594 17.8263 18.7126 18.0005 18.7126 18.2438V18.7479H19.9067V18.2438C19.9067 18.0005 19.8599 17.8263 19.7658 17.721ZM14.1021 21.5163C14.205 21.5584 14.3138 21.5783 14.4284 21.5783C14.5945 21.5783 14.7149 21.5385 14.7933 21.4566C14.8716 21.3759 14.9102 21.2414 14.9102 21.0566V18.1421C14.9102 17.9456 14.8623 17.7971 14.7664 17.6953C14.6699 17.5935 14.529 17.5432 14.3466 17.5432C14.25 17.5432 14.1547 17.5619 14.0605 17.5994C13.9664 17.638 13.8734 17.6976 13.7816 17.7771V21.3116C13.8916 21.4075 13.9986 21.4753 14.1021 21.5163ZM22.9915 15.3456C22.9915 13.9421 21.5499 12.8041 19.7734 12.8041C17.2389 12.7187 14.6454 12.6813 11.9995 12.6859C9.3545 12.6813 6.76096 12.7187 4.22563 12.8041C2.44996 12.8041 1.00846 13.9421 1.00846 15.3456C0.901722 16.4555 0.855503 17.5666 0.859628 18.6777C0.85555 19.7888 0.901722 20.8999 1.00846 22.011C1.00846 23.4133 2.44996 24.5513 4.22563 24.5513C6.76096 24.6355 9.3545 24.673 11.9995 24.6694C14.6454 24.673 17.2389 24.6355 19.7734 24.5513C21.5499 24.5513 22.9915 23.4133 22.9915 22.011C23.0979 20.8999 23.1441 19.7888 23.1394 18.6777C23.1441 17.5666 23.0979 16.4555 22.9915 15.3456ZM5.68316 22.418V22.5023H4.16099V22.418V15.7702H2.58617V15.6872V14.6276V14.5445H7.2583V14.6276V15.6872V15.7702H5.68316V22.418ZM11.098 16.693V22.418V22.5023H9.74657V22.418V21.8602C9.49686 22.0976 9.23807 22.2765 8.96882 22.4005C8.69896 22.5233 8.43753 22.5853 8.18375 22.5853C7.87147 22.5853 7.63607 22.4987 7.47758 22.3268C7.31882 22.1537 7.23955 21.8941 7.23955 21.5479V21.4636V16.693V16.6099H8.59161V16.693V21.0625C8.59161 21.1993 8.61969 21.2999 8.67608 21.3607C8.73313 21.4227 8.82491 21.4531 8.95152 21.4531C9.05122 21.4531 9.17666 21.4122 9.32872 21.3315C9.48017 21.2496 9.61935 21.1455 9.74657 21.0192V16.693V16.6099H11.098V16.693ZM16.3015 18.0766V21.2145V21.2988C16.3015 21.7116 16.1956 22.0274 15.984 22.2473C15.7722 22.4648 15.4658 22.5747 15.0658 22.5747C14.8015 22.5747 14.5665 22.5326 14.3594 22.4484C14.1518 22.3631 13.9595 22.232 13.7817 22.0554V22.418V22.5022H12.4174V22.418V14.6275V14.5445H13.7817V14.6275V17.0789C13.9641 16.9011 14.1571 16.7666 14.3618 16.6754C14.5671 16.583 14.7747 16.5363 14.984 16.5363C15.4108 16.5363 15.7384 16.6602 15.9635 16.9082C16.1886 17.1561 16.3015 17.5175 16.3015 17.9924V18.0766ZM21.2979 18.2544V19.6497V19.7339H18.7126V20.7455C18.7126 21.0508 18.757 21.2625 18.8459 21.3806C18.9354 21.4988 19.0874 21.5584 19.3026 21.5584C19.5266 21.5584 19.6839 21.5081 19.7734 21.4076C19.8622 21.3081 19.9067 21.0871 19.9067 20.7455V20.4263V20.3421H21.2979V20.4263V20.7783V20.8625C21.2979 21.4578 21.1289 21.9058 20.7898 22.2075C20.4511 22.5093 19.9453 22.659 19.2722 22.659C18.667 22.659 18.191 22.4988 17.843 22.1795C17.4957 21.8602 17.3214 21.4204 17.3214 20.8625V20.7783V18.2544V18.1714C17.3214 17.6673 17.5126 17.2567 17.8939 16.9386C18.2758 16.6216 18.77 16.4626 19.3746 16.4626C19.9933 16.4626 20.4681 16.6099 20.8003 16.9035C21.1313 17.1971 21.2979 17.6205 21.2979 18.1714V18.2544H21.2979Z"
																fill="white"
															/>
														</svg>
													</div>
													YouTube
												</Link>
											</li> */}
										</ul>
									</div>
								</div>
								<h2>Contact Us</h2>
							</div>
							<ContactUsPage />
						</div>
					</div>
				</div>
			</section>
		</>
	);
}
